import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import axios from 'axios'
// import VueAxios from 'vue-axios'
import store from '@/store'
import 'vuex'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/main.css'
import "js-cookie";

const app = createApp(App);
app.use(router, axios);
app.use(store);
app.mount('#app');
